const fieldGroups = {
  resetToSelect: 'General',
  rotationStep: 'General',
  showValenceWarnings: 'General',
  atomColoring: 'General',
  font: 'General',
  fontsz: 'General',
  fontszsub: 'General',
  showStereoFlags: 'Stereochemistry',
  stereoLabelStyle: 'Stereochemistry',
  colorOfAbsoluteCenters: 'Stereochemistry',
  colorOfAndCenters: 'Stereochemistry',
  colorOfOrCenters: 'Stereochemistry',
  colorStereogenicCenters: 'Stereochemistry',
  autoFadeOfStereoLabels: 'Stereochemistry',
  absFlagLabel: 'Stereochemistry',
  andFlagLabel: 'Stereochemistry',
  orFlagLabel: 'Stereochemistry',
  mixedFlagLabel: 'Stereochemistry',
  ignoreChiralFlag: 'Stereochemistry',
  carbonExplicitly: 'Atoms',
  showCharge: 'Atoms',
  showValence: 'Atoms',
  showHydrogenLabels: 'Atoms',
  aromaticCircle: 'Bonds',
  bondSpacing: 'Bonds',
  bondThickness: 'Bonds',
  stereoBondWidth: 'Bonds',
  'smart-layout': 'Server',
  'ignore-stereochemistry-errors': 'Server',
  'mass-skip-error-on-pseudoatoms': 'Server',
  'gross-formula-add-rsites': 'Server',
  'gross-formula-add-isotopes': 'Server',
  miewMode: '3D Viewer',
  miewTheme: '3D Viewer',
  miewAtomLabel: '3D Viewer',
  showAtomIds: 'Options for Debugging',
  showBondIds: 'Options for Debugging',
  showHalfBondIds: 'Options for Debugging',
  showLoopIds: 'Options for Debugging',
};

export default fieldGroups;
